import { render, staticRenderFns } from "./InvoiceItemsSummary.vue?vue&type=template&id=e03df4be&scoped=true&"
import script from "./InvoiceItemsSummary.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItemsSummary.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceItemsSummary.vue?vue&type=style&index=0&id=e03df4be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03df4be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow})
